import React from "react";

class Page7 extends React.Component {
  state = {
    visible: true,
  };
  checkPageVisibility(pageNum) {
    if (pageNum == 4) {
      this.setState({
        visible: true,
      });
    } else {
      this.setState({
        visible: false,
      });
    }
  }
  render() {
    return (
      <div>
        {this.state.visible ? (
          <div>
            <nav className="navbar fixed-top navbar-expand-sm bg-light page-title">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <h3 className="py-0 d-md-block">Learning Points</h3>
                </li>
                <li className="nav-item"></li>
              </ul>
            </nav>

            <div className="container-fluid h-100 vertical-center ">
              <div className="row h-100 justify-content-center">
                <div className="col-lg-8 col-md-12 col-sm-12 col-xs-12">
                  <div className="card mb-4 box-shadow" id="pageContent">
                    <div className="card-body d-flex flex-column text-dark">
                      <span id="moduleContentText_2">
                        <p>
                          <ol>
                            <li>
                              Recruitment for graduate schemes and some PhD
                              programmes starts a year in advance, therefore you
                              need to be prepared to start applying almost as
                              soon as you start your postgraduate studies.
                            </li>
                            <br />
                            <li>
                              Get ahead of the game by updating your CV and
                              LinkedIn profile. Do as much research as you can
                              into the opportunities you are considering.
                            </li>
                            <br />
                            <li>
                              Prioritise booking a 1:1 meeting with the Careers
                              Service as soon as you are on campus.
                            </li>
                            <br />
                            <li>
                              Ensure you have assessed your Digital Skills
                              capabilities.
                            </li>
                          </ol>
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default Page7;
